/*
 * @Author: qiong
 * @Description: 名片
 * @LastEditTime: 2021-09-23 11:09:24
 */
import React, { Component } from 'react';
import { Flex } from 'antd-mobile';
import { toJS } from 'mobx';

import QRCode from 'qrcode.react';
import Config from 'config/Config';

// import BusinessCardMod from './indexMod';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import { inject, observer } from 'mobx-react';
import './index.less';
import { openCardTextLess, oldOpenCardText } from 'utils/constants';

const CDN_BASE = Config.CDN_BASE || '';
@inject('AppMod')
@inject('BusinessCard')
@observer
class BusinessCard extends Component {
  static defaultProps = {
    customOnClick: false
  };
  constructor(props, context) {
    super(props, context);
    // this.stores = new BusinessCardMod();
    this.stores = this.props.BusinessCard;
    this.appStore = this.props.AppMod;
    this.state = {
      enlargeCode: false, // 是否展示二维码弹框
      qrCodeImgSrc_1: '',
      qrCodeImgSrc_2: ''
    };
  }

  componentDidMount = async () => {
    if (!this.stores.info.id || this.stores.info.userId != this.props.shareUserId) {
      await this.stores.getCardInfo(this.props.shareUserId);
    }
    if (!!this.stores.info.id) {
      // 生成二维码图片 存在渲染异步
      setTimeout(() => {
        const canvas = document.querySelector('.business-card #canvasCard_1');
        if (canvas) {
          this.setState({
            qrCodeImgSrc_1: canvas.toDataURL('image/png')
          });
        }
      }, 600);
    }
  };

  /**
   * 二维码字符串拼接(拼接为开卡地址，并携带健康顾问)
   */
  getCode = (info) => {
    const { globalAjaxJson } = this.appStore;
    const location = window.location;
    const { host, hash, protocol } = location;
    console.log('112', globalAjaxJson, location);
    let hostUrl = `${window.location.origin}${window.location.pathname}`;
    if (globalAjaxJson && globalAjaxJson.domainLIst && globalAjaxJson.domainLIst.length > 0) {
      hostUrl = `${protocol}//${globalAjaxJson.domainLIst[0]}/`;
    }
    console.log('hostUrl', `${hostUrl}#/register/memCardMsg?memberNum=${info.carNo || ''}`);
    return `${hostUrl}#/register/memCardMsg?memberNum=${info.carNo || ''}`;
  };

  /**
   * 显示大二维码
   */
  showLargeCode = () => {
    const qrCodeImgSrc_2 = '';
    this.setState({
      enlargeCode: true,
      qrCodeImgSrc_2:
        qrCodeImgSrc_2 ||
        document.querySelector('.business-card #canvasCard_2').toDataURL('image/png')
    });
  };

  render() {
    const { info, isSecret } = toJS(this.stores);
    const { name, phone } = this.props.businessCardInfo;
    console.log('name: ', name, 'phone: ', phone);
    const { enlargeCode, qrCodeImgSrc_1, qrCodeImgSrc_2 } = this.state;
    return info && info.name ? (
      <div className="business-card" style={{ display: info.id ? 'block' : 'none' }}>
        {/* 卡片资料 */}
        <div className="card-box">
          <div className="msg-group">
            <img src={info.avatar} className="msg-proplePhonto" />
            <img src={`${CDN_BASE}/assets/imgs/bg/my_message.png`} className="msg-bgImg" />
            <h3 className="ellipsis-one">{name || info.name}</h3>
            <div className="msg-item">
              <label className="ellipsis-one">{info.signature}</label>
            </div>
            <Flex direction="column" justify="between" class="msg-data">
              <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <label>联系电话: </label>
                  {phone || info.phone}
                </div>
                {!!isSecret &&
                  !!info.phone &&
                  !this.props.shareUserId &&
                  info.phone.indexOf('*') != -1 && (
                    <div
                      onClick={async () => {
                        let decyptPhone = await this.props.AppMod.getDecyptMsg({
                          scene: 224,
                          id: this.stores.info.id,
                          channel: ''
                        });
                        this.stores.changeState({
                          info: { ...this.stores.info, phone: decyptPhone }
                        });
                      }}>
                      点击查看
                    </div>
                  )}
              </p>
              {!!info.wechatShowStatus && (
                <p>
                  <label>微信号: </label>
                  {info.wechat}
                </p>
              )}
              {!!info.wechatShowStatus && (
                <p>
                  <label>QQ: </label> {info.qq}
                </p>
              )}
            </Flex>
            <div class="qrcode-fat">
              <img
                src={qrCodeImgSrc_1}
                className="sm-qrcode"
                // onClick={() => this.showLargeCode()}
                onClick={() => {
                  if (!!this.props.customOnClick) {
                    this.props.clickQRcode(
                      document
                        .querySelector('.business-card #canvasCard_2')
                        .toDataURL('image/png') || ''
                    );
                  } else {
                    this.showLargeCode();
                  }
                }}
              />
            </div>
            <QRCode id="canvasCard_1" style={{ display: 'none' }} value={this.getCode(info)} />
          </div>
        </div>
        {/* 二维码弹出框 */}
        {enlargeCode && <div className="mask" />}
        <div className="qrcode-box" style={{ display: enlargeCode ? 'block' : 'none' }}>
          <QRCode id="canvasCard_2" style={{ display: 'none' }} value={this.getCode(info)} />
          <img src={qrCodeImgSrc_2} className="lg-qrcode" />
          <p>
            扫码邀请
            {this.props.AppMod
              ? this.props.AppMod.getLYStr
              : `${
                  this.appStore.userInfo && this.appStore.userInfo.memberRetail
                    ? openCardTextLess
                    : oldOpenCardText
                }`}
          </p>
          <i
            className="iconfont icon-close2"
            onClick={() => this.setState({ enlargeCode: false })}
          />
        </div>
      </div>
    ) : null;
  }
}

module.exports = BusinessCard;



// WEBPACK FOOTER //
// ./src/pubBiz/BusinessCard/index.js